module.exports = __webpack_public_path__ + "assets/teacher-min.b64de9fb2f8f7d92f4a361ef07dd83fa.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Catlish/teacher-min.jpg
 ** module id = 401
 ** module chunks = 0
 **/